import React, { Component } from 'react';
import * as Sentry from '@sentry/browser';

import styled from 'styled-components';
import { Redirect } from 'react-router-dom';
import api from '../../../services/api';
import { useHistoryPush } from '../../../services/hooks/UseHistoryPush';
import checkForm from '../images/check-form.svg';
import List from '../../List';
import MoldalFooter from '../MoldalFooter';
import AlertStatus from '../../AlertStatus';
import ScrollTop from '../../Utils/ScrollTop';

const StyledSelectSourceBriefing = styled.section`
	font-family: Poppins-Regular, Heltica, Arial, sans-serif;
`;
const Title = styled.h1`
	text-transform: uppercase;
	font-size: 2.6em;
	color: #505059;
	margin: 70px 0 30px 0;
	text-align: center;
`;

const StyledList = styled.div`
	display: flex;
	justify-content: center;
    table {
    	width: 850px;
    	tr td button.btn-simple {
    		font-size: 0.9em;
    	}
    }
`;

export default class SelectSourceBriefing extends Component {
	state = {
		briefings: [],
		messageError: {
			show: false,
			text: '',
		},
		loading: true,
	};

	componentDidMount() {
		api.get('/briefings')
			.then((response) => {
				const briefings = this.filterBriefings(response.data.data);
				this.setState({ briefings, loading: false });
			})
			.catch((error) => {
				this.showMessageError(error);
			});
	}

	showMessageError = error => this.setState({
		messageError: {
			show: true,
			text: error.response.data.errors.map(value => value.message).join(','),
		},
	}, () => {
		setTimeout(this.hideMessageError, 10000);
	});

	hideMessageError = () => this.setState({
		messageError: {
			show: false,
			text: '',
		},
	});

	filterBriefings = response => response.filter(briefing => briefing.status === 2);

	cloneBriefing = (briefing) => {
		const { location } = this.props;
		const briefingId = location.state.briefingId;
		this.hideMessageError();
		api.post(`/briefings/${briefingId}/receive-answers/${briefing.id}`, {})
			.then((response) => {
				if (response.data.success) {
					return useHistoryPush('/briefing', { briefingId, cloned: true, pre_sale_id: briefing.pre_sale_id });
				}
				return Sentry.captureException(response);
			})
			.catch((error) => {
				this.showMessageError(error);
			});
	};

	renderList = () => {
		const { briefings, loading } = this.state;
		return (
			<StyledList className="table-responsive">
				<List
					loading={loading}
					dataThead={['Pré-venda', 'Data', 'Valor', 'Duração', '']}
					dataTbody={briefings}
					button={{ classButton: 'btn-simple', value: 'UTILIZAR ESSE BRIEFING', onClick: this.cloneBriefing }}
				/>
			</StyledList>
		);
	};

	buttonBackClick = () => {
		const { location } = this.props;

		return useHistoryPush('/briefing/clonar', { briefingId: location.state.briefingId, pre_sale_id: location.state.pre_sale_id });
	};

	render() {
		const { location } = this.props;
		const { messageError } = this.state;
		if (typeof location.state === 'undefined' || location.state.briefingId <= 0) {
			return <Redirect to="./briefings" />;
		}
		const sourceId = location.state.pre_sale_id || '';
		return (
			<StyledSelectSourceBriefing className="component-briefing">
				<ScrollTop />
				<div className="container-begin-briefing">
					<div className="container-fluid">
						<div className="row">
							<div className="col-12">
								<h2>Bem-vindo ao Briefing - Gearbox Mídia</h2>
							</div>
						</div>

						<div className="box-content">
							<div className="row">
								<div className="col-12">
									<div className="box-title">
										<img src={checkForm} alt="ícone formulário" className="icon-form" />
										<h3>{sourceId}</h3>
									</div>
								</div>
							</div>

							<div className="row">
								<div className="col-12">
									<Title>Escolha o briefing</Title>
									{ this.renderList() }
								</div>
							</div>

							<div className="row">
								<div className="col-12 text-center">
									{messageError.show ? (
										<AlertStatus
											message={messageError.text}
											status="error"
										/>
									) : ''}
								</div>
							</div>

							<div className="row">
								<div className="col-12">
									<div className="content-buttons mt-3 mb-5 text-center">
										<button
											type="button"
											className="btn btn-light"
											onClick={this.buttonBackClick}
										>
											Voltar
										</button>
									</div>
								</div>
							</div>

							<div className="row">
								<div className="col-12">
									<MoldalFooter />
								</div>
							</div>
						</div>
					</div>
				</div>
			</StyledSelectSourceBriefing>
		);
	}
}
